export const DISTRICTS = [
  // Región de Arica y Parinacota
  "Arica", "Camarones", "Putre", "General Lagos",
  
  // Región de Tarapacá
  "Iquique", "Alto Hospicio", "Pozo Almonte", "Camiña", "Colchane", "Huara", "Pica",
  
  // Región de Antofagasta
  "Antofagasta", "Mejillones", "Sierra Gorda", "Taltal",
  "Calama", "Ollagüe", "San Pedro de Atacama",
  "Tocopilla", "María Elena",
  
  // Región de Atacama
  "Copiapó", "Caldera", "Tierra Amarilla",
  "Chañaral", "Diego de Almagro",
  "Vallenar", "Freirina", "Huasco", "Alto del Carmen",
  
  // Región de Coquimbo
  "La Serena", "Coquimbo", "Andacollo", "La Higuera", "Paihuano", "Vicuña",
  "Illapel", "Canela", "Los Vilos", "Salamanca",
  "Ovalle", "Combarbalá", "Monte Patria", "Punitaqui", "Río Hurtado",
  
  // Región de Valparaíso
  "Valparaíso", "Casablanca", "Concón", "Juan Fernández", "Puchuncaví", "Quilpué", "Quintero", "Villa Alemana", "Viña del Mar",
  "Isla de Pascua",
  "Los Andes", "Calle Larga", "Rinconada", "San Esteban",
  "La Ligua", "Cabildo", "Papudo", "Petorca", "Zapallar",
  "Quillota", "Calera", "Hijuelas", "La Cruz", "Nogales",
  "San Antonio", "Algarrobo", "Cartagena", "El Quisco", "El Tabo", "Santo Domingo",
  "San Felipe", "Catemu", "Llaillay", "Panquehue", "Putaendo", "Santa María",
  
  // Región Metropolitana de Santiago
  "Santiago", "Cerrillos", "Cerro Navia", "Conchalí", "El Bosque", "Estación Central", "Huechuraba", "Independencia", "La Cisterna", "La Florida", "La Granja", "La Pintana", "La Reina", "Las Condes", "Lo Barnechea", "Lo Espejo", "Lo Prado", "Macul", "Maipú", "Ñuñoa", "Pedro Aguirre Cerda", "Peñalolén", "Providencia", "Pudahuel", "Quilicura", "Quinta Normal", "Recoleta", "Renca", "San Joaquín", "San Miguel", "San Ramón", "Vitacura",
  "Puente Alto", "Pirque", "San José de Maipo",
  "Colina", "Lampa", "Tiltil",
  "San Bernardo", "Buin", "Calera de Tango", "Paine",
  "Melipilla", "Alhué", "Curacaví", "María Pinto", "San Pedro",
  "Talagante", "El Monte", "Isla de Maipo", "Padre Hurtado", "Peñaflor",
  
  // Región del Libertador General Bernardo O'Higgins
  "Rancagua", "Codegua", "Coinco", "Coltauco", "Doñihue", "Graneros", "Las Cabras", "Machalí", "Malloa", "Mostazal", "Olivar", "Peumo", "Pichidegua", "Quinta de Tilcoco", "Rengo", "Requínoa", "San Vicente",
  "Pichilemu", "La Estrella", "Litueche", "Marchihue", "Navidad", "Paredones",
  "San Fernando", "Chépica", "Chimbarongo", "Lolol", "Nancagua", "Palmilla", "Peralillo", "Placilla", "Pumanque", "Santa Cruz",
  
  // Región del Maule
  "Talca", "Constitución", "Curepto", "Empedrado", "Maule", "Pelarco", "Pencahue", "Río Claro", "San Clemente", "San Rafael",
  "Cauquenes", "Chanco", "Pelluhue",
  "Curicó", "Hualañé", "Licantén", "Molina", "Rauco", "Romeral", "Sagrada Familia", "Teno", "Vichuquén",
  "Linares", "Colbún", "Longaví", "Parral", "Retiro", "San Javier", "Villa Alegre", "Yerbas Buenas",
  
  // Región de Ñuble
  "Chillán", "Bulnes", "Cobquecura", "Coelemu", "Coihueco", "El Carmen", "Ninhue", "Ñiquén", "Pemuco", "Pinto", "Portezuelo", "Quillón", "Quirihue", "Ránquil", "San Carlos", "San Fabián", "San Ignacio", "San Nicolás", "Treguaco", "Yungay",
  "Chillán Viejo",
  
  // Región del Biobío
  "Concepción", "Chiguayante", "Coronel", "Florida", "Hualpén", "Hualqui", "Lota", "Penco", "San Pedro de la Paz", "Santa Juana", "Talcahuano", "Tomé",
  "Lebu", "Arauco", "Cañete", "Contulmo", "Curanilahue", "Los Álamos", "Tirúa",
  "Los Ángeles", "Antuco", "Cabrero", "Laja", "Mulchén", "Nacimiento", "Negrete", "Quilaco", "Quilleco", "San Rosendo", "Santa Bárbara", "Tucapel", "Yumbel", "Alto Biobío",
  
  // Región de La Araucanía
  "Temuco", "Carahue", "Cunco", "Curarrehue", "Freire", "Galvarino", "Gorbea", "Lautaro", "Loncoche", "Melipeuco", "Nueva Imperial", "Padre Las Casas", "Perquenco", "Pitrufquén", "Pucón", "Saavedra", "Teodoro Schmidt", "Toltén", "Vilcún", "Villarrica",
  "Angol", "Collipulli", "Curacautín", "Ercilla", "Lonquimay", "Los Sauces", "Lumaco", "Purén", "Renaico", "Traiguén", "Victoria",
  
  // Región de Los Ríos
  "Valdivia", "Corral", "Lanco", "Los Lagos", "Máfil", "Mariquina", "Paillaco", "Panguipulli",
  "La Unión", "Futrono", "Lago Ranco", "Río Bueno",
  
  // Región de Los Lagos
  "Puerto Montt", "Calbuco", "Cochamó", "Fresia", "Frutillar", "Los Muermos", "Llanquihue", "Maullín", "Puerto Varas",
  "Castro", "Ancud", "Chonchi", "Curaco de Vélez", "Dalcahue", "Puqueldón", "Queilén", "Quellón", "Quemchi", "Quinchao",
  "Osorno", "Puerto Octay", "Purranque", "Puyehue", "Río Negro", "San Juan de la Costa", "San Pablo",
  "Chaitén", "Futaleufú", "Hualaihué", "Palena",
  
  // Región de Aysén del General Carlos Ibáñez del Campo
  "Coyhaique", "Lago Verde",
  "Aysén", "Cisnes", "Guaitecas",
  "Cochrane", "O'Higgins", "Tortel",
  "Chile Chico", "Río Ibáñez",
  
  // Región de Magallanes y de la Antártica Chilena
  "Punta Arenas", "Laguna Blanca", "Río Verde", "San Gregorio",
  "Puerto Natales", "Torres del Paine",
  "Porvenir", "Primavera", "Timaukel",
  "Cabo de Hornos", "Antártica"
];
